require('./main/common.js');
require('./main/region_changer.js')

require('./main/mobile')
